import { useDispatch, useSelector } from "react-redux";
import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import { State } from "../../../../reducers";
import useComprobanteLiquidacion from "../../../../actions/comprobante-liquidacion";
import { useEffect, useState } from "react";

import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto";
import SearchIcon from "../../../../media/white_search_icon.svg";
import { Pagination } from "../../../../components/Pagination";
import { bindActionCreators } from "redux";
import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import ObservacionesDocumentoBase from "../../../../components/ObservacionesDocumento/ObservacionesDocumento";
import { COMPROBANTE_LIQUIDACION_TYPES } from "../../../../constants/comprobante-liquidacion.types"
import { getMinDateRetroactiva } from "../../../../utils/stringDate";
import InputChips from "../InputChips";

export default function FormulariosCL (){
    const {fecha_actual} = useSelector((state: State) => state.general)
    const config = useSelector((state: State) => state.userLogin.config)
    const {formCliente, errorsCliente, productos, loader_asociarDocumentos, documentosAsociados, documentosEncontrados, tableProductos, formObservaciones} = useSelector((state: State) => state.comprobanteLiquidacion)
    const {tipoDocumento, departamentos, municipios, actividadesEconomicas, tipoDocumentosEmision, datosEmisor} = useSelector((state: State) => state.catalogos)
    const {
        onChangeFormCliente,
        cargarDatosIniciales,
        buscarCliente,
        buscarDocumentosAsociados,

        validateFormCliente,

        actionButton_asociar,
        actionButton_desasociar,
        actionButton_editarDocumentoFisico,
        buttonActiveModalBusquedaDocumentos,
        setTableProductos,

        cargarSucursales,
        calculosDocumentos,
        button_agreagarDocumentoFisico
    } = useComprobanteLiquidacion()
    const dispatch = useDispatch()

    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {validateHorarioSucursal, validateUsoModulo, getFechaHora} = bindActionCreators(actionGeneral, dispatch)

    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }
    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    let sumaOperaciones = 0
    let iva = 0
    let subtotal = 0
    let ivaPercibido = 0
    let ivaRetenido = 0
    let retencionRenta = 0
    let total = 0
    productos.forEach((producto) => {
        let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
        let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
        let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

        sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)

        if(!producto.exento){
            iva += ivaProducto
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
        } else {
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
        }
    })
    
    total = subtotal

    useEffect(() => {
        validateUsoModulo()
        validateHorarioSucursal()
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        getFechaHora()
    }, [])

    useEffect(() => {
        setTableProductos(documentosAsociados)
    }, [documentosAsociados])
    
    const [tableDocumentosAsociados, setTableDocumentosAsociados] = useState<Array<any>>([])


    return(
        <>
        <div className="otros-documentos-container">
            <div className='dos-columnas-resp'>
            <div className='form-content'>
            <BasicCardDocumentos title="Datos del cliente">
                {/* <InputForm required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {formCliente.granContribuyente} onChange = {(e: any) => onChangeFormCliente('granContribuyente', !formCliente.granContribuyente)}/> */}
                <div className='w-layout-hflex h-inputs'>
                    <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date'
                        value = {config?.facturacion_retroactiva ? formCliente.fecha : (fecha_actual?.FechaInput || formCliente.fecha)}
                        disabled = {!config?.facturacion_retroactiva}
                        min = {config?.facturacion_retroactiva && config?.dias_facturacion_retroactiva && fecha_actual?.FechaInput ? getMinDateRetroactiva(config.dias_facturacion_retroactiva, fecha_actual.FechaInput) : undefined}
                        max = {config?.facturacion_retroactiva ? fecha_actual?.FechaInput : undefined}
                        error = {errorsCliente.fecha}
                        onChange = {config?.facturacion_retroactiva ? (e: any) => onChangeFormCliente('fecha', e.target.value) : undefined}
                    />
                    {/* <InputForm required options = {tipoDocumento} keyNameText = 'valor' keyNameValue = 'codigo' name = 'tipoDocumento' placeholder = 'Tipo de documento de identificación' label = 'Tipo de documento de identificación' type = 'select' value = {formCliente.tipoDocumento} error = {errorsCliente.fecha} onChange = {(e: any) => onChangeFormCliente('tipoDocumento', e.value)}/> */}
                    <InputForm onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = 'NIT' label = 'NIT' type = 'text' value = {formCliente.noDocumento} error = {errorsCliente.noDocumento} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombre} error = {errorsCliente.nombre} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm required options = {departamentos} keyNameText = 'valor' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {formCliente.departamento} error = {errorsCliente.departamento} onChange = {(e: any) => onChangeFormCliente('departamento', e.value)}/>
                    <InputForm required options = {municipios} keyNameText = 'valor' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {formCliente.municipio} error = {errorsCliente.municipio} onChange = {(e: any) => onChangeFormCliente('municipio', e.value)}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {formCliente.direccion} error = {errorsCliente.direccion} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputChips maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => onChangeFormCliente('chipsEmail', chipsEmail)} maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/>
                    {/* <InputForm onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {formCliente.actividad} error = {errorsCliente.actividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                    <InputForm onBlur = {handleBlurFormCliente} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {formCliente.telefono} error = {errorsCliente.telefono} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <div className='label-input'>
                    <InputForm maxLength = {10} required onBlur = {handleBlurFormCliente} name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {formCliente.nrc} error = {errorsCliente.nrc} onChange = {handleChangeFormCliente}/>
                    </div><div className='label-input'></div>
                </div>
            </BasicCardDocumentos>
            </div> 
            <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
            <BasicCardDocumentos title="Sucursal y serie">
                <div className='w-layout-hflex h-inputs'>
                    <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                    <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                </div>
                <div>
                    <h3 className="card-title">Documentos</h3>
                </div>
                <hr className="separador"/>
                    {documentosAsociados?.length > 0 ?
                                    <div className="tab-plane">
                                    <div className="table-facturacion-resp">
                                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                                        <thead>
                                            <tr>
                                                <td>Correlativo</td>
                                                <td>Tipo de documento</td>
                                                <td>Fecha de emisión</td>
                                                <td>Acciones</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableDocumentosAsociados.map((documento: any) => {
                                                let fechaSplit = documento?.fechaEmision.split(' ')[0].split('-')
                                                let fecha = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`
                                                let fechaYHora = `${fecha} ${documento?.fechaEmision.split(' ')[1]}`   
                                                
                                                return(
                                                <tr>
                                                    <td data-label="Correlativo">{documento?.numeroControl}</td>
                                                    <td data-label="Tipo de documento">{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.tipoDocumento)?.nombre}</td>
                                                    <td data-label="Fecha y hora">{fechaYHora}</td>
                                                    <td data-label="Acciones">
                                                            {documento?.tipoGeneracion === 1 &&
                                                            <button style={{borderRadius: '4px'}}  onClick={() => actionButton_editarDocumentoFisico(documento)} >Editar</button>
                                                            }
                                                            <button 
                                                                onClick={() => actionButton_desasociar(documento?.numeroControl)}
                                                                style={{borderRadius: '4px', background: 'red', color: '#fff'}} 
                                                            >
                                                                Quitar
                                                            </button>
                                                    </td>
                                                </tr>
                                            )})}
                                        </tbody>
                                    </table>
                                    </div>
                                    <div style={{display: 'flex', width: '100%',justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px', margin: '10px'}}>
                                        {/* <button onClick={() => buttonActiveModalBusquedaDocumentos(true)} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Buscar documentos</button> */}
                                        <button onClick={button_agreagarDocumentoFisico} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Agregar documento físico</button>
                                    </div>
                                    <Pagination data = {documentosAsociados} state = {(items: Array<any>) => setTableDocumentosAsociados(items)} items = {5}/>
                                    </div>
                                    :
                                    <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px'}}>
                                        Sin documentos asociados.
                                        {/* <button onClick={() => buttonActiveModalBusquedaDocumentos(true)} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Buscar documentos</button> */}
                                        <button onClick={button_agreagarDocumentoFisico} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Agregar documento físico</button>
                                    </div>
                    }
            </BasicCardDocumentos>
            </div>
            </div>
            <div className="w-100">
            <div className="w-layout-layout bill-section wf-layout-layout">
            <BasicCardDocumentos title="Detalle de documentos" style={{maxWidth: "100%", boxShadow: "none"}}>
            <div className="tab-plane">
                <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Tipo de DTE</td>
                                <td>Numero de documento</td>
                                <td>Fecha de generación</td>
                                <td>Venta gravada</td>
                                <td>Venta no sujeta</td>
                                <td>Venta exenta</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableProductos?.map((documento, index) => {
                                let fechaSplit = documento?.fechaEmision?.split(' ')[0]?.split('-')
                                let fecha = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`
                                let gravada = 0
                                let noSujeta = 0
                                let exenta = 0
                                if(documento?.tipoGeneracion === 2){
                                    switch(documento?.tipoDocumento){
                                        case '01':
                                            gravada = parseFloat(documento?.resumen?.totalGravada || '0')/1.13
                                            break;
                                        default:
                                            gravada = parseFloat(documento?.resumen?.totalGravada || '0')
                                            break;
                                    }
                                } else {
                                    noSujeta = parseFloat(documento?.resumen?.noSujeto || '0')
                                    exenta = parseFloat(documento?.resumen?.exentas || '0')
                                    gravada =  
                                        parseFloat(documento?.tipoDocumento === '11' ? documento?.resumen?.exportaciones : documento?.resumen?.gravadas || '0')
                                }

                                return(
                                <tr key={index}>
                                    <td data-label="Tipo de DTE">{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.tipoDocumento)?.nombre}</td>
                                    <td data-label="Numero de documento">{documento?.numeroControl}</td>
                                    <td data-label="Fecha de generación">{fecha}</td>
                                    <td data-label="Venta gravada">{gravada?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Venta no sujeta">{(documento?.resumen?.totalNoSuj || noSujeta)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Venta exenta">{(documento?.resumen?.totalExenta || exenta)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            )})}
                        </tbody>
                    </table>
                </div>
                    <Pagination data = {documentosAsociados} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones no sujetas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesNoSujetas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>total de operaciones exentas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesExentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones gravadas</td>
                                    <td>{calculosDocumentos().test_totalOperacionesGravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Total de operaciones de exportación</td>
                                    <td>{calculosDocumentos().test_totalOperacionesExportacion.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Monto total de la operación</td>
                                    <td>{calculosDocumentos().test_montoTotalOperacion.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Impuesto al Valor Agregado 13%</td>
                                    <td>{calculosDocumentos().test_iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-descuento">
                                    <td>IVA percibido</td>
                                    <td>{calculosDocumentos().test_ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{calculosDocumentos().test_total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
            </BasicCardDocumentos>
            </div>
            </div>
        </div>
        <div className="otros-documentos-container" style={{paddingBottom: '0'}}>
            <div style={{marginBottom: '-10px'}} id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
                <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={(field, value) => dispatch({ type: COMPROBANTE_LIQUIDACION_TYPES.CL_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })} />
                <DocumentosReceptor />
            </div>
        </div>
        </>
    )
}